import { render, staticRenderFns } from "./RegistrationPeriodEdit.vue?vue&type=template&id=03ea0956"
import script from "./RegistrationPeriodEdit.vue?vue&type=script&lang=js"
export * from "./RegistrationPeriodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports